<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="6">
        <div class="pa-3">
          <ExpireTotal :total="count_number"/>
        </div>
        <div class="pa-4">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table show-select v-model="selected" checkbox-color="#86bc3a" :headers="refunHeaders" :items="refunList" item-key="warehouse_id" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.warehouse_id">
                  <td><v-checkbox color="#86bc3a" v-model="selected" :value="item"/></td>
                  <td>{{ item.lot_no }}</td>
                  <td>{{ item.product_name }}</td>
                  <td>{{ diffDateTH(item.date_expired) }}</td>
                  <td>{{ format_number(item.quantity) }}</td>
                  <td>{{ item.unit }}</td>
                  <td>{{ item.supplier }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
        <div class="pa-6 text-right">
          <v-btn x-large class="grad-warning-bg white--text mobile_btn" @click="save_data">ย้ายเข้าคลังทิ้ง</v-btn>
        </div>
        <v-overlay :value="overlay" class="z_index">
          <div class="text-center">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
                color="#86bc3a"
            ></v-progress-circular>
            <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
          </div>
        </v-overlay>
      </v-card>
    </div>
  </div>
</template>

<script>
import ExpireTotal from "./header_expire/ExpireTotal";
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {formatNumber} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Drop_product",
  components: {
    ExpireTotal
  },
  data() {
    return {
      loading_page: false,
      search: '',
      selected: [],
      count_number: '',
      overlay: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      refunHeaders: [
        // {
        //   text: 'จัดการ',
        //   value: 'status_check',
        //   fixed: true,
        //   width: '100px',
        // },
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '350px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier',
          fixed: true,
          width: '250px',
        },
      ],
      refunList: [],
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    diffDateTH(value) {
      if (value !== null) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0]) + 543
        return day+'/'+month+'/'+year
      }
      else {
        value = ''
        return value
      }
    },
    get_trashData() {
      this.loading_page = true
      HTTP.post('/inventory/expireds/cannotreturn')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.refunList = res.data.object
              console.log(res.data.object)
              this.count_number = res.data.count
              if (this.count_number <= 0) {
                this.count_number = '0'
              }else if (this.count_number < 10) {
                this.count_number = '0'+this.count_number
              }
              // res.data.object.forEach((data, index) => {
              //   this.refunList[index].status_check = false
              // })
            }
          })
    },
    save_data() {
      // const value = this.refunList.filter((data) => data.status_check === true)
      // value.forEach((data) => {
      //   if (data.status_check === true) {
      //     data.status_check = 1
      //   }
      //   else {
      //     data.status_check = 0
      //   }
      // })
      if (this.selected.length > 0) {
        Swal.fire({
          title: 'ต้องการย้ายเข้าคลังทิ้งหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.overlay = true
            HTTP.post('/inventory/expireds/movetodump', {
              user_create: this.$store.state.userDetail.id,
              user_name: this.$store.state.userDetail.name,
              data_list: this.selected,
            }).then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                Swal.fire({
                  title: 'ดำเนินการย้ายคลังสำเร็จ !',
                  icon: 'success',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                })
                this.get_trashData()
              }
            })
          }
          else {
            this.get_trashData()
          }
        })
      }else {
        Swal.fire({
          title: 'กรุณาเลือกข้อมูลที่ต้องการย้าย !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    }
  },
  mounted() {
    this.get_trashData()
  }
}
</script>

<style scoped>
.mobile_btn {
  width: 25%;
}
@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
}
</style>
